import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckAhComponent } from './check-ah.component';


const routes: Routes = [
  {
    path: '',
    component: CheckAhComponent,
    data: {
      title: "Tekshirish",
      breadcrumb: "Tekshirish"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CheckAhRoutingModule { }
